/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_TimezoneInputs */

const th_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เขตเวลา`)
};

const en_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time zone`)
};

const ja_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムゾーン`)
};

const zh_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时区`)
};

const es_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona horaria`)
};

const pt_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuso horário`)
};

const id_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona waktu`)
};

const fr_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuseau horaire`)
};

const tl_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time zone`)
};

const vi_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Múi giờ`)
};

const ko_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시간대`)
};

const de_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitzone`)
};

const ru_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Часовой пояс`)
};

const tr_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat dilimi`)
};

const it_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuso orario`)
};

const pl_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strefa czasowa`)
};

const uk_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Часовий пояс`)
};

const hi_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय क्षेत्र`)
};

const ar_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المنطقة الزمنية`)
};

const ms_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zon waktu`)
};

const bn_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সময় অঞ্চল`)
};

const zh_tw2_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時區`)
};

const zh_hk2_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時區`)
};

const ur_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وقت کا علاقہ`)
};

const fa_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منطقهٔ زمانی`)
};

const sw_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saa za eneo`)
};

const nl_event_timezone = /** @type {(inputs: Event_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tijdzone`)
};

/**
* | output |
* | --- |
* | "Time zone" |
*
* @param {Event_TimezoneInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_timezone = /** @type {((inputs?: Event_TimezoneInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_TimezoneInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_timezone(inputs)
	if (locale === "ja") return ja_event_timezone(inputs)
	if (locale === "zh") return zh_event_timezone(inputs)
	if (locale === "es") return es_event_timezone(inputs)
	if (locale === "pt") return pt_event_timezone(inputs)
	if (locale === "id") return id_event_timezone(inputs)
	if (locale === "fr") return fr_event_timezone(inputs)
	if (locale === "tl") return tl_event_timezone(inputs)
	if (locale === "vi") return vi_event_timezone(inputs)
	if (locale === "ko") return ko_event_timezone(inputs)
	if (locale === "de") return de_event_timezone(inputs)
	if (locale === "ru") return ru_event_timezone(inputs)
	if (locale === "tr") return tr_event_timezone(inputs)
	if (locale === "it") return it_event_timezone(inputs)
	if (locale === "pl") return pl_event_timezone(inputs)
	if (locale === "uk") return uk_event_timezone(inputs)
	if (locale === "hi") return hi_event_timezone(inputs)
	if (locale === "ar") return ar_event_timezone(inputs)
	if (locale === "ms") return ms_event_timezone(inputs)
	if (locale === "bn") return bn_event_timezone(inputs)
	if (locale === "zh-TW") return zh_tw2_event_timezone(inputs)
	if (locale === "zh-HK") return zh_hk2_event_timezone(inputs)
	if (locale === "ur") return ur_event_timezone(inputs)
	if (locale === "fa") return fa_event_timezone(inputs)
	if (locale === "sw") return sw_event_timezone(inputs)
	if (locale === "nl") return nl_event_timezone(inputs)
	return en_event_timezone(inputs)
});